import { customerEmailFilterModel } from "config/filterModels/customerEmailFilterModel";
import { customerPhoneNumberFilterModel } from "config/filterModels/customerPhoneNumberFilterModel";
import { dateFilterModel } from "config/filterModels/dateFilterModel";
import { invoiceIdFilterModel } from "config/filterModels/invoiceIdFilterModel";
import { FilterModel } from "model/Filter.model";

export const invoicesFilterConfig: FilterModel[] = [dateFilterModel, invoiceIdFilterModel, customerPhoneNumberFilterModel, customerEmailFilterModel];
